export const AlertsKeysList = ["no", "sm", "na", "lb", "ht", "ga", "pl", "or", "fu", "ed", "re", "fi", "ti", "up", "ul", "mn"];
export const AlertsTypesCharts = function () {
    return {
        sm: [], // Movimiento brusco - AA
        na: [], // No envio de datos
        lb: [], // Bateria baja - AB
        ht: [], // Alta temperatura - AC
        ga: [], // Alerta señal GSM -
        pl: [], // Nivel de llenado - AD
        or: [], // Fuera de rango - BA
        fu: [], // Alerta de llenado rapido- BB
        ed: [], // Alerta de vaciado rapido - AF
        re: [], // Alerta de reset - AE
        fi: [], // Alerta de fuego - AC
        ti: [], // Alerta de volcado - BC
        up: [], // Alerta de enderezado - BD
        ul: [], // Descarga detectada (limpieza de lecturas)
    };
};

export const AlertsTypes = {
    BATTERY_LOW: "lb",
    TEMPERATURE_HIGH: "ht",
    GSM_SIGNAL_LOW: "ga",
    LEVEL_UP: "pl",
    OUT_OF_RANGE: "or",
    FILLING_ALERT: "fu",
    EMPTYING_ALERT: "ed",
    RESET: "re",
    FIRE: "fi",
    MOVEMENT: "sm",
    NO_DATA_SENT: "na",
    TIPPING: "ti",
    UPRIGHT: "up",
    UNLOAD: "ul",
};
export const AlertsFields = {
    pl: "dist", // LEVEL_UP
    fu: "difllen", // FILLING_ALERT
    ed: "difvac", // EMPTYING_ALERT
    getField: function (type) {
        try {
            if (type && type in this) {
                return this[type];
            }
        } catch (e) {
            console.log("Error al obtener el campo de la alerta:", e);
        }
        return undefined;
    },
};
/*
legend. icon
string
Icon of the legend items.

Icon types provided by ECharts includes

'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
* */
export const AlertsChartsParams = {
    keys: {
        sm: {
            // Movimiento brusco
            title: "alerts_types.sm",
            backgroundColor: "rgb(48,175,6)",
            borderColor: "rgb(48,175,6)",
            icon: "rect",
        },
        na: {
            // No envio de datos
            title: "alerts_types.na",
            backgroundColor: "rgb(23,23,23)",
            borderColor: "rgb(23,23,23)",
            icon: "diamond",
        },
        lb: {
            // Bateria baja
            title: "alerts_types.lb",
            backgroundColor: "rgb(255,69,0)",
            borderColor: "rgb(255,69,0)",
            icon: "circle",
        },
        ht: {
            // Alta temperatura
            title: "alerts_types.ht",
            backgroundColor: "rgb(255,174,0)",
            borderColor: "rgb(255,174,0)",
            icon: "circle",
        },
        fi: {
            // Alerta de fuego
            title: "alerts_types.fi",
            backgroundColor: "rgb(255,69,0)", // Rojo fuego
            borderColor: "rgb(255,69,0)",
            icon: "circle",
        },
        ga: {
            // Alerta señal GSM
            title: "alerts_types.ga",
            backgroundColor: "rgb(160,92,255)",
            borderColor: "rgb(160,92,255)",
            icon: "circle",
        },

        or: {
            // Fuera de rango
            title: "alerts_types.or",
            backgroundColor: "rgb(96,101,108)",
            borderColor: "rgb(96,101,108)",
            icon: "circle",
        },
        pl: {
            // Nivel subida, no se paque
            title: "alerts_types.pl",
            backgroundColor: "rgb(255,69,0)",
            borderColor: "rgb(255,69,0)",
            icon: "circle",
        },
        fu: {
            // Alerta de llenado
            title: "alerts_types.fu",
            backgroundColor: "rgb(255,174,0)",
            borderColor: "rgb(255,174,0)",
            icon: "circle",
        },
        ed: {
            // Alerta de vaciado
            title: "alerts_types.ed",
            backgroundColor: "rgb(0,197,167)",
            borderColor: "rgb(0,197,167)",
            icon: "circle",
        },
        re: {
            // Reinicio
            title: "alerts_types.re",
            backgroundColor: "rgb(133,34,4)",
            borderColor: "rgb(133,34,4)",
            icon: "diamond",
        },
        ti: {
            // Nivel subida, no se paque
            title: "alerts_types.ti",
            backgroundColor: "rgb(255,69,0)",
            borderColor: "rgb(255,69,0)",
            icon: "rect",
        },
        up: {
            // Alerta de recolocado
            title: "alerts_types.up",
            backgroundColor: "rgb(48,175,6)",
            borderColor: "rgb(48,175,6)",
            icon: "rect",
        },
        ul: {
            // Descarga detectada: igual que el vaciado rápido
            title: "alerts_types.ul",
            backgroundColor: "rgb(0,197,167)",
            borderColor: "rgb(0,197,167)",
            icon: "circle",
        },
    },
    getAlertColor: function (type) {
        if (type && type in this.keys) {
            return this.keys[type].backgroundColor;
        }
        return "#888888"; // Gris por defecto
    },
    getTitle: function (type) {
        if (type && type in this.keys) {
            return this.keys[type].title;
        }
        return "Not defined";
    },
    getIcon: function (type) {
        if (type && type in this.keys) {
            return this.keys[type].icon;
        }
        return "circle";
    },
};
